import { WithRouterProps } from 'react-router';

import createRequiredContext from 'ha/core/RequiredContext';

const RouterContext =
  createRequiredContext<Omit<WithRouterProps, 'routes'>>('RouterContext');

export const RouterProvider = RouterContext.Provider;
export const RouterConsumer = RouterContext.Consumer;

const useRouter = RouterContext.useContext;

// named useHistory to be aligned with react-router v5 hooks to ease the potential upgrade
// router object is a wrapper around history with most functions being the same
// https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/api/hooks.md#usehistory
export const useHistory = () => {
  const { router } = useRouter();

  return router;
};

export const useLocation = () => {
  const { location } = useRouter();

  return location;
};

export const useParams = () => {
  const { params } = useRouter();

  return params;
};

export default RouterContext;
